import React from 'react';
import _, { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

function Taxpayer({
  taxpayer,
  transactionInfo,
}) {
  const spanGap = 8;

  return (
    <>
      <div className='px-3' style={{ maxHeight: '700px', overflowY: 'scroll' }}>
        <table className="transaction-table table table-borderless table-sm">
          <tbody>
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  REQUESTOR INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                First Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'first_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Middle Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'middle_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Last Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'last_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Extension Name
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'extension_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Sex
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {(_.get(taxpayer, 'gender') || '--').toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Civil Status
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {(_.get(taxpayer, 'civil_status') || '--').toUpperCase()}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Birth Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {moment(_.get(taxpayer, 'birth_date')).format('MMMM DD, YYYY') || '--'}
                </b>
              </td>
            </tr> 
            
            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  ADDRESS
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Region
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'region_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Province
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'province_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                City/Municipality
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'municipality_name') || '--'}</b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Barangay
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'barangay_name')}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Address Line 1
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(taxpayer, 'street') || '--'}</b>
              </td>
            </tr>

            <tr className='mt-3'>
              <td width="350">
                <span className="title" style={{ fontSize: '16px' }}>
                  CONTACT INFORMATION
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Email
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'email') || _.get(transactionInfo, 'attributes.email') || '--'}
                </b>
              </td>
            </tr>
            <tr>
              <td className="text-dark" colSpan={spanGap}>
                Mobile Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {_.get(taxpayer, 'mobile_number') || _.get(transactionInfo, 'attributes.mobile_number') || '--'}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

Taxpayer.defaultProps = {
  taxpayer: {},
  transactionInfo: {},
};

Taxpayer.propTypes = {
  taxpayer: PropTypes.instanceOf(Object),
  transactionInfo: PropTypes.instanceOf(Object),
};

export default Taxpayer;
